import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type OnboardingStages as SchemaOnboardingStages } from '../schemas/OnboardingStages';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Onboarding
 */
export const GetOnboardingStagesContentType = '' as const;
export type GetOnboardingStagesRequest = void;
export type GetOnboardingStagesResponses = LinkCommonErrorResponses & {
    /**
     * @description Success
     */
    '200': {
        'application/json': SchemaOnboardingStages;
    };
};
export type GetOnboardingStagesResponseSuccess = GetOnboardingStagesResponses['200']['application/json'];
export type GetOnboardingStagesSearchParams = undefined;
export type GetOnboardingStagesPathParameters = undefined;
export const GetOnboardingStagesUrl = '/onboarding/stages' as const;
export const GetOnboardingStagesMethod = 'GET' as const;
export const getGetOnboardingStagesUrl = (_params?: GetOnboardingStagesPathParameters) => GetOnboardingStagesUrl;
